import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

const getGameCarousels = async () => {
  return privateRequest.get(`${ConfEnv.API_CAROUSELS.URL_CAROUSELS}`);
};

export default getGameCarousels;
